<router-outlet></router-outlet>
<ng-progress ></ng-progress>
<div class="page-loader page-loader--inner">
    <div class="page-loader__spinner">
        <svg viewBox="25 25 50 50">
            <circle cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
    </div>
</div>
